import { render, staticRenderFns } from "./PageMetadata.vue?vue&type=template&id=5857fdb7&"
import script from "./PageMetadata.vue?vue&type=script&lang=js&"
export * from "./PageMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports